/**
 *排序
 * @param val [number,number]
 * @returns
 */
export function sortValue(val) {
  return val.sort(function (a, b) {
    return a - b;
  });
}
/**
 * 获取小数长度
 * @param n
 * @returns
 */
export function getDecimalLen(n) {
  return ("".concat(n).split(".")[1] || "").length;
}